import type { RefDataByKey } from '@/types/grid'

const refDataByKeyStoreById = new Map<string, RefDataByKey | undefined>()

export const setRefDataByKeyStore = (
  id: string,
  value: RefDataByKey | undefined,
): void => {
  refDataByKeyStoreById.set(id, value)
}

export const clearRefDataByKeyStore = (id: string): void => {
  refDataByKeyStoreById.delete(id)
}

export const getRefDataByKeyStore = (
  id: string | undefined,
): RefDataByKey | undefined => {
  if (!id) return undefined
  return refDataByKeyStoreById.get(id)
}
